import {
  consentUpdated, defaultPageView, scroll, pageError, defaultLinkClick,
  onsiteSearch, scAdd, prodView, scView, scRemove, scCheckout, purchase,
  audioStart, audioComplete, audioProgress,
} from './tracking-events';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    oneDataLayer: any[];
  }
}

const defaultItem: any = {
  event: undefined,
};

const trackingFunctions = {
  defaultPageView,
  consentUpdated,
  scroll,
  pageError,
  defaultLinkClick,
  onsiteSearch,
  scAdd,
  prodView,
  scView,
  scRemove,
  scCheckout,
  purchase,
  audioStart,
  audioComplete,
  audioProgress,
};

const trackingBaseType = (type: string) => (data: any) => {
  const trackingFunction = trackingFunctions[type];

  if (trackingFunction) {
    return {
      ...defaultItem,
      event: type,
      ...trackingFunction(data),
    };
  }

  return {
    ...defaultItem,
    event: type,
  };
};

export const AdobeTrackingService = {
  push(item: any = defaultItem): void {
    window.oneDataLayer = window.oneDataLayer || [];
    window.oneDataLayer.push({ ...item });
  },
};

export const AdobeTracking = (data: any, type: string) => {
  AdobeTrackingService.push(trackingBaseType(type)(data));
};
